import { cn } from '@/shared/helpers/cn';
import styles from './Skeleton.module.scss';

export interface SkeletonProps {
  /** Largura CSS. Padrao: 100%. */
  width?: string;
  /** Altura CSS. Padrao: uma linha de texto. */
  height?: string;
  /** Usa o raio do componente real que sera carregado. */
  radius?: 'sm' | 'md' | 'pill';
  className?: string;
}

/**
 * Bloco de carregamento.
 *
 * Usa o raio do componente real que vai substituí-lo, para que a troca nao
 * desloque o layout. A pulsacao desaparece sob `prefers-reduced-motion`.
 */
export function Skeleton({ width = '100%', height = '1rem', radius = 'sm', className }: SkeletonProps) {
  return (
    <span
      className={cn(styles.skeleton, styles[radius], className)}
      style={{ inlineSize: width, blockSize: height }}
      aria-hidden="true"
    />
  );
}

export interface SkeletonTextProps {
  lines?: number;
  className?: string;
}

/** Varias linhas de texto, com a ultima mais curta, como texto real. */
export function SkeletonText({ lines = 3, className }: SkeletonTextProps) {
  return (
    <span className={cn(styles.text, className)}>
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} width={index === lines - 1 ? '60%' : '100%'} />
      ))}
    </span>
  );
}
